export default [
  {
    key: "goods",
    label: "Goods and Services"
  },
  {
    key: "supplies",
    label: "Supplies"
  },
  {
    key: "clothing",
    label: "Clothing"
  },
  {
    key: "equipmnet",
    label: "Equipment"
  }
];
